import { c as _c } from "react/compiler-runtime";
import type { CalendarDate } from '@internationalized/date';
import { useRef } from 'react';
import { cx } from '../../../cx';
import { calendarDateToDate } from '../core/to-calendar-date';
import { useRangeCell } from '../core/use-range-cell';
import { cellStyles, dateStyles, wrapperStyles } from '../datepicker.styles';
import type { useDateRangePickerConfig } from './use-date-range-picker-config';
export type DayProps = Pick<ReturnType<typeof useDateRangePickerConfig>, 'state' | 'onChange' | 'isMobile' | 'pinnedAnchorDate' | 'setPinnedAnchorDate' | 'initialHideRangeMarkers' | 'allowsNonContiguousRanges' | 'renderDate'> & {
  date: CalendarDate;
  currentMonth: CalendarDate;
};
export function Day(t0) {
  const $ = _c(39);
  let props;
  let renderDate;
  if ($[0] !== t0) {
    ({
      renderDate,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = renderDate;
  } else {
    props = $[1];
    renderDate = $[2];
  }
  const ref = useRef(null);
  const {
    cell,
    conditions: t1,
    cellProps,
    buttonProps
  } = useRangeCell(props, ref);
  const {
    isFocusVisible,
    isOutsideMonth,
    isDisabledOrUnavailable,
    isHighlighted,
    isSelectedMarker,
    isSelectionStart,
    isSelectionEnd,
    isHighlightedEdge,
    isHighlightedSameDay,
    isHovered,
    isTodayCell,
    hideRangeMarkers
  } = t1;
  let t2;
  if ($[3] !== isFocusVisible) {
    t2 = cellStyles({
      isFocusVisible
    });
    $[3] = isFocusVisible;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== props.date) {
    t3 = props.date.toString();
    $[5] = props.date;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const t4 = !!isHighlighted;
  const t5 = isSelectionStart && isHighlightedEdge;
  const t6 = isSelectionEnd && isHighlightedEdge;
  const t7 = !!isHighlightedSameDay;
  const t8 = hideRangeMarkers && isSelectionStart;
  const t9 = hideRangeMarkers && isSelectionEnd;
  let t10;
  if ($[7] !== isDisabledOrUnavailable || $[8] !== isOutsideMonth || $[9] !== t4 || $[10] !== t5 || $[11] !== t6 || $[12] !== t7 || $[13] !== t8 || $[14] !== t9) {
    t10 = cx(wrapperStyles({
      isDisabled: isDisabledOrUnavailable,
      isEmpty: isOutsideMonth,
      isHighlighted: t4,
      isHighlightedStart: t5,
      isHighlightedEnd: t6,
      isHighlightedSameDay: t7,
      hiddenMarkerStart: t8,
      hiddenMarkerEnd: t9
    }));
    $[7] = isDisabledOrUnavailable;
    $[8] = isOutsideMonth;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
    $[12] = t7;
    $[13] = t8;
    $[14] = t9;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  const t11 = isTodayCell && !isSelectedMarker;
  let t12;
  if ($[16] !== isDisabledOrUnavailable || $[17] !== isFocusVisible || $[18] !== isHovered || $[19] !== isSelectedMarker || $[20] !== t11) {
    t12 = cx(dateStyles({
      isDisabled: isDisabledOrUnavailable,
      isFocusVisible,
      isMarker: isSelectedMarker,
      isHovered,
      disabledCursor: isDisabledOrUnavailable,
      todayMarker: t11
    }));
    $[16] = isDisabledOrUnavailable;
    $[17] = isFocusVisible;
    $[18] = isHovered;
    $[19] = isSelectedMarker;
    $[20] = t11;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== cell || $[23] !== props.date || $[24] !== renderDate) {
    t13 = renderDate?.({
      ...cell,
      date: calendarDateToDate(props.date)
    }) ?? cell.formattedDate;
    $[22] = cell;
    $[23] = props.date;
    $[24] = renderDate;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== t12 || $[27] !== t13) {
    t14 = <div className={t12}>{t13}</div>;
    $[26] = t12;
    $[27] = t13;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] !== buttonProps || $[30] !== isOutsideMonth || $[31] !== t10 || $[32] !== t14 || $[33] !== t3) {
    t15 = <div {...buttonProps} data-calendar-day={t3} ref={ref} hidden={isOutsideMonth} className={t10}>{t14}</div>;
    $[29] = buttonProps;
    $[30] = isOutsideMonth;
    $[31] = t10;
    $[32] = t14;
    $[33] = t3;
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  let t16;
  if ($[35] !== cellProps || $[36] !== t15 || $[37] !== t2) {
    t16 = <td {...cellProps} className={t2}>{t15}</td>;
    $[35] = cellProps;
    $[36] = t15;
    $[37] = t2;
    $[38] = t16;
  } else {
    t16 = $[38];
  }
  return t16;
}